import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import ForgetPasswordReducer from "./auth/forgotPassword/reducer";
import ProfileReducer from "./auth/profile/reducer";
import  categoryReducer from "./category/reducer"

//tosts
import toastReducer from "./toast/reducer";

// User

import quizeQuestion from "./question/reducer"
import quize from "./quize/reducer"
import candidateresult from "./candidateresult/reducer"
import settings from "./settings/reducer"
// import QuestionGenerate from "./QuestionGenerate/reducer"

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  toast: toastReducer,

  category:categoryReducer,
  quizeQuestion:quizeQuestion,
  QuizeData:quize,
  candidateResult:candidateresult,
  setting:settings,
  // QuestionGenrate:QuestionGenerate
});

export default rootReducer;
